import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchRecipes = async (category) => {
  const params = category ? { category } : {};
  const { data } = await axios.get(`${API}/recipes`, { params });
  return data;
};

export const fetchRecipe = async (slug) => {
  const { data } = await axios.get(`${API}/recipes/${slug}`);
  return data;
};

export const fetchCategories = async () => {
  const { data } = await axios.get(`${API}/categories`);
  return data.categories;
};
